<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'banner/index' }">
                                Banner
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Edit Banner
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Edit Banner
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <form v-on:submit.prevent="save">
                            <div class="form-group">
                                <label class="font-weight-medium">Upload Banner</label>
                                <input id="image" type="file" class="form-control" v-on:change="preview" placeholder="Choose File" accept="image/*" />
                                <label for="image" class="form-control form-control-sm">
                                    <button type="button" class="btn btn-danger btn-sm font-weight-bold">
                                        Choose File
                                    </button> 
                                </label>
                                <img v-bind:src="imagePreview" class="img-fluid mt-2 w-100" />
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required">Posisi Banner</label>
                                <select v-model="form.priority" class="form-control form-control-sm" required>
                                    <option disabled value="">Pilih Posisi...</option>
                                    <option v-for="n in maxCountBanner" v-bind:value="n"># {{ n }}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required">Judul Banner</label>
                                <input v-model="form.title" class="form-control form-control-sm" placeholder="Judul" required />
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required">Teks Banner</label>
                                <textarea v-model="form.description" class="form-control form-control-sm" placeholder="Deskripsi" spellcheck="false" required></textarea>
                            </div>
                            <div class="pt-3 text-center">
                                <button type="submit" class="btn btn-danger btn-sm px-5">
                                    Save
                                </button>
                                <router-link v-bind:to="{ name: 'banner/index' }" exact class="btn btn-outline-danger btn-sm px-5 ml-3">
                                    Cancel
                                </router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "BannerEdit",
        data() {
            return {
                form: {
                    title: '',
                    description: '',
                    priority: '',
                    image: ''
                },
                maxCountBanner: 0,
                imagePreview: '',
                banner: {}
            };
        },
        methods: {
            save() {
                var formData = new FormData();
                for (var attribute in this.form) {
                    formData.set(attribute, this.form[attribute]);
                }
                this.axios.post(process.env.API_URL + '/banner/update/' + this.$route.params.id, formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'banner/index'});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            preview(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.image = input.files[0];
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        this.imagePreview = event.target.result;
                    }.bind(this);
                    reader.readAsDataURL(input.files[0]);
                }
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/banner/' + this.$route.params.id),
                this.axios.get(process.env.API_URL + '/banner')
            ]).then(this.axios.spread(function (responseView, responseList) {
                var dataView = responseView.data.data;
                this.form = dataView;
                this.banner = dataView;
                this.imagePreview = dataView.imageUrl;
                this.maxCountBanner = responseList.data.data.length;

                document.title = this.banner.title + ' - Edit Banner - ' + process.env.APP_NAME;
            }.bind(this)));
        }
    };
</script>

<style scoped>
    img:not([src]), img[src=""]{
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/banner/Edit.vue